import { SalesNote, SalesNoteHead } from "interface/salesNote"

export interface Comment {
    id : number
    noteHeadId? : number
    lineNumber : number
    description : string
    noteLineId?: number
}


export const requirementFields ={
    recordNumberErs: false,
    //diaryNumber: false,
    //tripNumber: false,
    firstCatchDate: false,
    lastCatchDate: false,
     catchYear: false,
     crewSize: false,
     norwegianCrewSize: false,
    vesselOfficersNorwegian: false,
    vesselHullId: false,
   fishingGearId: false,
   catchField: false,
    quotaTypeCode: false,
    quotaVesselHullId: true,
   quotaNationCode: false,
    landingNationCode: false,
    partialLandingId: false,
    vesselCaptainsName: false,
    usageCode: false,
    buyerLegalEntitySubUnitNo: false,
    buyerFdirId: false,
    // productionFacilityId: false
}

const checkForNullsAndEmpty = (field: string | number | null | undefined) => {
    return field !== undefined && field !== null && field !== "";
}

const checkForNulls = (field: string | number | null | undefined) => {
    return field !== undefined && field !== null;
}

const  isPass = ( field : string | number | null | undefined, allowZero: boolean = false) => {
    return field !== null && field !== "" && field !== undefined && (allowZero || field !== 0);
}
export const handleRequirementCheck = (form: SalesNoteHead, recordNumberErs: boolean, isQuotaVessel: boolean) => {
    const requirementCheck = { ...requirementFields };
    const allowZero = true
    requirementCheck.recordNumberErs = recordNumberErs;
    //requirementCheck.diaryNumber = checkForNulls(form.diaryNumber);
    //requirementCheck.tripNumber = checkForNulls(form.tripNumber);
    requirementCheck.firstCatchDate = checkForNullsAndEmpty(form.firstCatchDate);
    requirementCheck.lastCatchDate = checkForNullsAndEmpty(form.lastCatchDate);
    requirementCheck.catchYear = checkForNulls(form.catchYear);
    requirementCheck.crewSize = checkForNulls(form.crewSize);
    requirementCheck.norwegianCrewSize = checkForNulls(form.norwegianCrewSize);
    requirementCheck.vesselOfficersNorwegian = isPass(form?.vesselOfficersNorwegian, allowZero);

    // requirementCheck.departureDate = form.departureDate !== null && form.departureDate !== "";
    // requirementCheck.arrivalDate = form.arrivalDate !== null && form.arrivalDate !== "";
    requirementCheck.quotaTypeCode = checkForNullsAndEmpty(form.quotaTypeCode);
    requirementCheck.quotaNationCode = checkForNullsAndEmpty(form.quotaNationCode);
    requirementCheck.landingNationCode = checkForNullsAndEmpty(form.landingNationCode);
    requirementCheck.partialLandingId = checkForNulls(form.partialLandingId);
    requirementCheck.vesselCaptainsName = checkForNullsAndEmpty(form.vesselCaptainsName);
    requirementCheck.vesselHullId = checkForNullsAndEmpty(form.vesselHullId);
    requirementCheck.fishingGearId = form.fishingGearId !== undefined && form.fishingGearId !== null && form.fishingGearId !== 0;
    requirementCheck.catchField = checkForNullsAndEmpty(form.catchField);
    requirementCheck.usageCode = checkForNullsAndEmpty(form.usageCode);
    requirementCheck.buyerLegalEntitySubUnitNo = checkForNullsAndEmpty(form.buyerLegalEntitySubUnitNo);
    requirementCheck.buyerFdirId = form.buyerFdirId !== undefined && form.buyerFdirId !== null && form.buyerFdirId !== 0;

    //requirementCheck.quotaVesselHullId = checkForNullsAndEmpty(form.quotaVesselHullId);
    //if (isQuotaVessel) {
    //    requirementCheck.quotaVesselHullId = checkForNullsAndEmpty(form.quotaVesselHullId);
    //} else {
    //    requirementCheck.quotaVesselHullId = true;
    //}

    if (!form.buyerLegalEntitySubUnitNo || form.buyerLegalEntitySubUnitNo === "") {
        // if buyerLegalEntitySubUnitNo is missing, we skip checking buyerFdirId since it depends on it
        requirementCheck.buyerFdirId = true;
        requirementCheck.buyerLegalEntitySubUnitNo = true // we set it to true here to avoid blocking the requirement check due to missing business data
    }
    return requirementCheck;
};
  
  
export const areAllRequirementsMet = (requirementCheck: typeof requirementFields) => {
    return Object.values(requirementCheck).every((value) => value === true);
};
  

export const stepTwoRequirementCheck = (form: any[], isAdmin: boolean = false) => {
    if (form.length === 0) {
        console.log('stepTwoRequirementCheck 2');
        return false;
    }

    for (const line of form) {
        if (
            line.productId === 0 ||
            line.packagingCode === "" ||
            line.packagingCode == null ||

            !line.grossLiveWeightKg ||
            line.grossLiveWeightKg === 0 ||
            line.grossLiveWeightKg < 0 ||

            !line.netLiveWeightKg || line.netLiveWeightKg === 0 || line.netLiveWeightKg < 0 ||

            (!isAdmin && (!line.price || line.price === 0 || line.price < 0))
        )
        {
            return false;
        }

        if (line.grossLiveWeightKg < line.netLiveWeightKg) {
            return false;
        }

        if (line.piecesMandatory === 1) {
            if (!line.numberOfPieces || line.numberOfPieces === 0) {
                return false;
            }
        }
    }

    return true;
}